// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piegraph {
  width: 250px !important;
  height: 240px !important;
  /* padding: 8px; */
  margin: auto;
  position: relative;
  bottom: 28px;
  /* left: 60px; */
}
.systemgraph {
  width: 250px !important;
  height: 228px !important;
  /* padding: 8px; */
  margin: auto;
  position: relative;
  bottom: 22px;
  /* left: 60px; */
}

.bargraph {
  height: 210px !important;
  width: 300px !important;
  margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Document/Graphs/graph.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".piegraph {\r\n  width: 250px !important;\r\n  height: 240px !important;\r\n  /* padding: 8px; */\r\n  margin: auto;\r\n  position: relative;\r\n  bottom: 28px;\r\n  /* left: 60px; */\r\n}\r\n.systemgraph {\r\n  width: 250px !important;\r\n  height: 228px !important;\r\n  /* padding: 8px; */\r\n  margin: auto;\r\n  position: relative;\r\n  bottom: 22px;\r\n  /* left: 60px; */\r\n}\r\n\r\n.bargraph {\r\n  height: 210px !important;\r\n  width: 300px !important;\r\n  margin: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
